import React from 'react';
import IcSupport from 'assets/images/backoffice/capital/ic-support.svg';
import Button from '../Button';
import styles from './InfoCard.css';
import InfoCard from './InfoCard';

function MoreFAQ(props) {
  const { visitWebsiteUrl, title, faqTitle, faqURL } = props;
  return (
    <InfoCard
      title={title || 'Butuh informasi lebih lanjut?'}
      icon={<img src={IcSupport} className={styles.phone} />}
    >
      <div className={styles['contact-capital-wrapper']}>
        <div className={styles.row}>
          <Button
            full
            title={faqTitle || 'Baca FAQ'}
            btnType="outline"
            href={
              faqURL ||
              'https://mokaposhelp.zendesk.com/hc/en-us/sections/360003335313-Moka-Capital'
            }
            target="_blank"
          />
        </div>
        {visitWebsiteUrl && (
          <div className={styles.row}>
            <Button
              full
              title="Kunjungi Website"
              btnType="outline"
              href={visitWebsiteUrl}
              target="_blank"
            />
          </div>
        )}
      </div>
    </InfoCard>
  );
}

export default MoreFAQ;
